import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProtectedRoute = ({ children, redirectTo = '/login', adminOnly = false }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
        withCredentials: true,
      });
      const userData = response.data;
      if (adminOnly && userData.role !== 'admin') {
        setIsAuthenticated(false);
        navigate('/dashboard', { replace: true });
        return;
      }
      setUser(userData);
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
      navigate(redirectTo, { state: { from: location.pathname } });
    }
  }, [navigate, redirectTo, adminOnly, location.pathname]);

  useEffect(() => {
    if (location.state?.user) {
      const userData = location.state.user;
      if (adminOnly && userData.role !== 'admin') {
        navigate('/dashboard', { replace: true });
        return;
      }
      setUser(userData);
      setIsAuthenticated(true);
      return;
    }
    checkAuth();
  }, [location, checkAuth, adminOnly, navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
        <div className="w-16 h-16 border-4 border-[#1A4331] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return isAuthenticated ? React.cloneElement(children, { user }) : null;
};

export default ProtectedRoute;
